import { ComponentType } from 'react';

export enum PropertyFilterType {
  dropdown = 'dropdown',
  search = 'search',
  date = 'date',
  hidden = 'hidden',
  checkbox = 'checkbox',
}

export type FilterCompoundValue<T extends string> =
  | `${T};${T}`
  | `${T};${T};${T}`
  | `${T};${T};${T};${T}`
  | `${T};${T};${T};${T};${T}`; //limited to 5 values for simplicity

export type SearchPropertyFilter = PropertyFilter & {
  type: PropertyFilterType.search;
  placeholder: ((count: number) => string) | string;
  // Shortest search term the page applies. Shorter, non-empty terms show a hint and are not sent.
  minLength?: number;
};

export type PropertyFilter<TValue extends string = string> = {
  key: string;
  label?: string;
  Icon?: ComponentType<{ className?: string }>;
  type: PropertyFilterType;
  value: string;
  dropDownOptions?: {
    dropdownValues: Array<{ label: string; value: TValue | FilterCompoundValue<TValue> }>;
    dropdownDefaultLabel?: string;
    defaultToFirstValue?: boolean;
    multiple?: boolean;
    isLoading?: boolean;
    // When set, each selected option also carries a single-choice sub-option
    // (e.g. direction Both/Incoming/Outgoing), encoded as `VALUE:SUBVALUE` tokens.
    // The first ("default") choice is the bare token with no suffix.
    subOptions?: {
      defaultLabel: string;
      values: Array<{ value: string; label: string }>;
    };
  };
  placeholder?: ((count: number) => string) | string;
  endDate?: string;
  endDateLimit?: Date;
  eventDetails?: {
    event: string;
    properties?: Record<string, any>;
  };
};

export type FilterValue = {
  key: string;
  value: string;
};

export type Filter = {
  cursor?: string | null;
  perPage?: string | null;
  filterValues?: Array<FilterValue>;
  include?: string;
  sort?: string | null;
};
